import { useEffect } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter } from "react-router-dom";
import StartUp from "./components/StartupIndia";
import StartupNMPVideo from "./components/StartupNMPVideo";
import HowItWorks from "./components/HowItWorks";
import FindHomeMentor from "./components/FindHomeMentor";
import JoinHomeMentorship from "./components/JoinHomeMentorship";
import MapSection from "./components/MapSection";
import { getHomePageData } from "./dependencies/action";
import { initGA, logPageView } from "../../analytics";
import { useTranslation } from 'react-i18next';
import MentorShipPlatform from "../AboutUs/components/MentorShipPlatform/MentorShipPlatform";
const HomePage = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    // const languageSelect=localStorage.getItem("SelectedLang")
    
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      
      logPageView();
    } catch (error) {}
  }, [window]);

  const {
    getHomePageData,
    currentInterventionList,
  } = props;
 
  useEffect(() => {
   
    getHomePageData(localStorage.getItem("SelectedLang"));
    
  }, [getHomePageData]);
  
  const keyFunctionData =[
    `${t('AI_engine_to_match_relevant_mentors_and_startups')}`,
    // "AI engine to match relevant mentors and startups",
    `${t('Track_mentor_and_startup_interactions_to_deliver_impact')}`,
    // "Track mentor and startup interactions to deliver impact",
    `${t('Enable_video_calls_and_communication_via_platform')}`,
    // "Enable video calls and communication via platform",.
    `${t('Mobile_friendly_interface_for_ease_of_use')}`,
    // "Mobile friendly interface for ease of use",
    `${t('Recognition_and_benefits_for_mentor_contribution')}`,
    // "Recognition and benefits for mentor contribution",
    `${t('Facilitate_ecosystem_enablers_to_host_custom_programs')}`,
    // "Facilitate ecosystem enablers to host custom programs",
    `${t('Provide_feedback_query_and_grievance_mechanism')}`,
    // "Provide feedback, query, and grievance mechanism"
];
const meta={
  title: 'MAARG',
  description: '',
  canonical: 'https://maarg.startupindia.gov.in/',
  meta: {
      charset: 'utf-8',
      name: {
          keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
      }
  }
};
  return (
    <DocumentMeta {...meta}>
      <div>

        <StartUp
          data={
            currentInterventionList &&
            currentInterventionList.Bannersliders.First
          }/>

        <StartupNMPVideo
          data={
            currentInterventionList &&
            currentInterventionList.Bannersliders.Second
          }/>

        <MentorShipPlatform data={keyFunctionData}/>

        <HowItWorks
          data={currentInterventionList && currentInterventionList.HowitWorks}/>

        <FindHomeMentor
          data={currentInterventionList && currentInterventionList.GetAmentor}/>
      
        <JoinHomeMentorship
          data={currentInterventionList && currentInterventionList.mentor}/> 

        <MapSection />
      </div>
    </DocumentMeta>
  );
};

const mapStateToProps = (state) => {
  return {
    currentInterventionList: state.HomeReducer.currentInerventionList.list,
  };
};
export default connect(mapStateToProps, { getHomePageData })(
  withRouter(HomePage)
);
